import SectionHeading from "./SectionHeading";

const PRINCIPLES = [
  {
    icon: "ri-git-merge-line",
    title: "来龙去脉，一线到底",
    text: "每个瓜局都不只讲“发生了什么”，更讲“为什么会发生”，把前因后果串联成清晰的故事线。",
  },
  {
    icon: "ri-exchange-funds-line",
    title: "多源交叉求证",
    text: "我们尽量比对多方信源与不同立场，标注存疑之处，避免单方面信源带偏整段叙述。",
  },
  {
    icon: "ri-history-line",
    title: "完整时间线还原",
    text: "用精确到日、可信可查的时间轴，还原事件从发酵、发酵到定局的全程，不错过任何一个关键节点。",
  },
  {
    icon: "ri-shield-check-line",
    title: "中立理性呈现",
    text: "吃瓜不等于站队。我们克制情绪、减少臆测，把判断的空间留给你。",
  },
];

const QUOTES = [
  {
    text: "以前追瓜全靠各平台刷碎片，现在一个专题就把来龙去脉讲明白了，时间线也一目了然，省了我大半夜。",
    name: "追瓜十年的老粉",
    tag: "深度吃瓜党",
  },
  {
    text: "最难得的是它不急着下结论，会把不同的说法都摆出来再标注哪些存疑，读起来踏实很多。",
    name: "关注行业舆情的媒体人",
    tag: "栏目读者",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="mx-auto w-full max-w-7xl scroll-mt-24 px-4 py-14 md:px-6 md:py-20" aria-label="关于我们">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
        <div>
          <SectionHeading
            align="left"
            icon="ri-question-answer-line"
            kicker="关于我们"
            title="吃瓜资讯，是认真的"
            desc="我们是一群相信“信息不该只有碎片”的编辑与研究者。把热搜背后被折叠的细节重新摊开，是吃瓜资讯存在的全部理由。"
          />
          <p className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-base">
            当热点越来越快、真相越来越散，普通观众很难凭几条热搜拼出完整图景。
            吃瓜资讯的每一位编辑都以“厘清来龙去脉”为己任：我们追踪信源、比对口径、
            复核时间，把每个复杂瓜局整理成可以放心阅读的深度专题，让深度吃瓜不再费力。
          </p>

          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {PRINCIPLES.map((p) => (
              <div
                key={p.title}
                className="rounded-2xl border border-background-200 bg-background-100 p-4"
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                  <i className={`${p.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h4 className="mt-3 text-sm font-bold text-foreground-900">{p.title}</h4>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">
                  {p.text}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* 口碑与数据 */}
        <div className="space-y-5">
          <div className="grid grid-cols-3 gap-4">
            {[
              { num: "300+", label: "年度专题", icon: "ri-folder-5-line" },
              { num: "6+", label: "平均信源", icon: "ri-git-branch-line" },
              { num: "96%", label: "读者满意度", icon: "ri-heart-3-fill" },
            ].map((s) => (
              <div
                key={s.label}
                className="rounded-2xl bg-primary-500 p-5 text-center text-background-50"
              >
                <i className={`${s.icon} text-2xl text-primary-100`} aria-hidden="true"></i>
                <p className="mt-2 font-display text-2xl md:text-3xl">{s.num}</p>
                <p className="mt-1 text-xs text-primary-100">{s.label}</p>
              </div>
            ))}
          </div>

          <div className="overflow-hidden rounded-3xl bg-accent-100">
            <img
              src="https://readdy.ai/api/search-image?query=editorial%20newsroom%20desk%20with%20open%20laptop%20magazines%20and%20cup%20of%20tea%2C%20warm%20cozy%20melon%20green%20and%20cream%20tone%2C%20soft%20natural%20window%20light%2C%20documentary%20style%20photography&width=1600&height=1000&seq=about-team&orientation=landscape"
              alt="吃瓜资讯编辑部日常工作桌面"
              className="aspect-[8/5] w-full object-cover object-top"
            />
          </div>

          <div className="space-y-3">
            {QUOTES.map((q) => (
              <figure
                key={q.name}
                className="rounded-2xl border border-background-200 bg-background-100 p-5"
              >
                <blockquote className="text-sm leading-relaxed text-foreground-700">
                  “{q.text}”
                </blockquote>
                <figcaption className="mt-3 flex items-center gap-2">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-200 text-secondary-800">
                    <i className="ri-user-3-line" aria-hidden="true"></i>
                  </span>
                  <span className="text-xs">
                    <span className="font-semibold text-foreground-900">{q.name}</span>
                    <span className="ml-2 text-foreground-400">{q.tag}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}